var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3407 50.6518H24.2151V30.9256H30.3407V50.6518ZM27.2746 28.2347C25.3158 28.2347 23.7271 26.6123 23.7271 24.6535C23.7271 23.7126 24.1008 22.8103 24.7661 22.145C25.4314 21.4797 26.3337 21.106 27.2746 21.106C28.2155 21.106 29.1178 21.4797 29.7831 22.145C30.4484 22.8103 30.8222 23.7126 30.8222 24.6535C30.8222 26.6123 29.2327 28.2347 27.2746 28.2347ZM53.267 50.6518H47.1545V41.0492C47.1545 38.7607 47.1084 35.8258 43.9697 35.8258C40.7849 35.8258 40.2968 38.3122 40.2968 40.8843V50.6518H34.1778V30.9256H40.0528V33.6164H40.1386C40.9564 32.0665 42.9541 30.4309 45.9344 30.4309C52.1339 30.4309 53.2736 34.5134 53.2736 39.8159V50.6518H53.267Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.7675,
    height: 33.7675,
    fill: "white",
    transform: "translate(21.6162 21.1045)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinicon);
export default __webpack_public_path__ + "static/media/linkedinicon.d34185bfd6d16337d1f28881234ec87c.svg";
export { ForwardRef as ReactComponent };